module.exports = __webpack_public_path__ + "static/media/google-news-initiative.c3460cc2.jpg";